import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import Button, { BUTTON_HEIGHT_32 } from '../../Button'
import { FloatingTooltip } from '../../Floating'

import { QA_NAME_BLOCK_EDIT_DISABLED } from './RentalPortalBlockDisabledEditButton.constants'

import * as styles from './RentalPortalBlockDisabledEditButton.module.css'

import EditIcon from '../../../icons/edit.svg'

function RentalPortalBlockDisabledEditButton({
  tooltipKey = 'RentalPortal.BlockEditNotAllowedTooltipKey',
}) {
  const { t } = useTranslation()

  return (
    <FloatingTooltip
      content={t(tooltipKey)}
      placement={FLOATING_ELEMENT_PLACEMENT.top}
    >
      <span className={styles.tooltipWrapper}>
        <Button.Outlined
          disabled
          isGrey
          beforeIconProps={{ Icon: EditIcon }}
          height={BUTTON_HEIGHT_32}
          qaName={QA_NAME_BLOCK_EDIT_DISABLED}
        />
      </span>
    </FloatingTooltip>
  )
}

export default RentalPortalBlockDisabledEditButton
